import { createSlice } from "@reduxjs/toolkit";

import {
  decryptPayload,
  getObjLength,
  reactPixelEventOnlyForCustomer,
} from "../../../components/helpers/utils";

const intialPropertiesState = {
  propertiesData: [],
  propertiesCount: 6,
  getPropertyData: {},
  verifiedPropertiesList: {},
  propertyVerified: {},
  propertyQuestion: {},
  getSearchedPropertyData: {},
  userPropertyData: {},
  selectedProperty: {},
  editPropertiesDetails: {},
  propertiesLoader: false,
  propertiesListLoaded: false,
  propertiesListError: null,
  documentTypes: {},
  requestDoc: {},
  generateDoc: {},
  reqLoader: false,
  propertyLoader: false,
  propertyPayment: {},
  cancelSubscriptionDetails: {},
  cancelSubscriptionMetaData: {},
  cancelSubscriptionLoader: false,
  showSecurityInfoScreen: false,
  viewDetailsPropertyData: {},
  subscriptionHistoryLoader: false,
  subscriptionHistory: [],
  selectedUserID: null,
  isQuestionByPass: false,
  isSubscriptionByPass: false,
  verificationLoader: false,
  isBypassOptionAvailable: false,
  addSubscriptionLoader: false,
  addSubscriptionDetails: {},
  selectedPropertiesData: {},
  securityPropertiesQueData: {},
  verifySecurityInfoData: {},
  stopSubscriptionData: {},
  genearteQuesPayload: {},
  userViewDetailsPropertyData: {},
  ttbDocumentDetails: {},
  ttbDocumentLoader: false,
  propertyFlowOpenSources: {},
  pendingPropertyFlowReset: false,
};

const properties = createSlice({
  name: "propertiesDetails",
  initialState: intialPropertiesState,
  reducers: {
    resetState: () => intialPropertiesState,
    //  for modal
    clearPropertiesList(state, action) {
      console.log("properties list==>", action.payload);
      state.getPropertyData = {};
      state.verifiedPropertiesList = {};
      state.propertyVerified = {};
      state.getSearchedPropertyData = {};
      // state.propertyQuestion = {};
      // state.documentTypes = {};
      state.generateDoc = {};
      state.reqLoader = false;
      state.propertyPayment = {};
      state.paymentLoader = false;
      state.viewDetailsPropertyData = {};
      if (action.payload !== "error") {
        state.selectedProperty = {};
        state.selectedUserID = null;
      }
      state.isQuestionByPass = false;
      state.isSubscriptionByPass = false;
      state.verificationLoader = false;
      state.isBypassOptionAvailable = false;
      state.propertyLoader = false;
      state.basicMonitoringData = {};
      state.basicMonitoringLoader = false;
      state.securityPropertiesQueData = {};
      state.propertyQuestion = {};
    },
    //for logout
    resetProperties(state, action) {
      state.propertiesData = [];
      state.propertiesCount = 0;
      state.propertiesListLoaded = false;
      state.propertiesLoader = true;
      state.propertiesListError = null;
      state.getPropertyData = {};
      state.verifiedPropertiesList = {};
      state.propertyVerified = {};
      state.propertyQuestion = {};
      state.selectedProperty = {};
      state.documentTypes = {};
      state.generateDoc = {};
      state.reqLoader = false;
      state.viewDetailsPropertyData = {};
      state.selectedUserID = null;
      state.propertyLoader = false;
    },
    fetchPropertyList(state, action) {
      state.propertiesLoader = true;
      console.log("property payload==>>", action.payload);
    },
    // Add Property / Add Subscription / Upgrade Subscription register here
    // while they are open ({ source, open }). The customer list POST resets the
    // modal-owned state only when nothing is registered (see propertySaga).
    setPropertyFlowOpen(state, action) {
      const { source, open } = action.payload || {};
      if (!source) {
        return;
      }
      if (open) {
        state.propertyFlowOpenSources[source] = true;
      } else {
        delete state.propertyFlowOpenSources[source];
      }
    },
    // List POST fired while a flow was still open (e.g. before the Security PIN
    // step): remember it and reset once the last modal closes.
    markPendingPropertyFlowReset(state) {
      state.pendingPropertyFlowReset = true;
    },
    // Reset everything Add Property / Add Subscription / Upgrade Subscription
    // leave behind, including the properties/generate-questions and
    // customer/customer-verify-answers responses. userSignUpSlice listens to
    // this same action for its half. The properties list itself is untouched.
    resetPropertyFlowState(state) {
      state.pendingPropertyFlowReset = false;
      // property search
      state.getPropertyData = {};
      state.userPropertyData = {};
      state.getSearchedPropertyData = {};
      state.selectedProperty = {};
      // properties/generate-questions
      state.propertyQuestion = {};
      state.genearteQuesPayload = {};
      state.securityPropertiesQueData = {};
      // customer/customer-verify-answers + other paymentForProperty endpoints
      state.propertyPayment = {};
      state.paymentLoader = false;
      state.addSubscriptionDetails = {};
      state.addSubscriptionLoader = false;
      // verification results
      state.propertyVerified = {};
      state.verifySecurityInfoData = {};
      state.verifiedPropertiesList = {};
      state.verificationLoader = false;
      // screen / bypass flags
      state.showSecurityInfoScreen = false;
      state.isQuestionByPass = false;
      state.isSubscriptionByPass = false;
      state.isBypassOptionAvailable = false;
      state.selectedUserID = null;
      state.propertyLoader = false;
    },
    clearPropertyPendingUnlock(state, action) {
      const propertyId = Number(action.payload?.propertyId);
      if (!propertyId) {
        return;
      }

      state.propertiesData = state.propertiesData.map((property) => {
        if (Number(property?.id) !== propertyId) {
          return property;
        }

        return {
          ...property,
          pending_unlock: null,
          is_termination_requested: false,
          is_waiver_requested: false,
          is_unlock_package: false,
        };
      });
    },
    setPropertyList(state, action) {
      const objectDictionary = {};

      state.propertiesData?.forEach((obj) => {
        objectDictionary[obj["id"]] = obj;
      });

      action.payload?.data?.forEach((obj) => {
        objectDictionary[obj["id"]] = obj;
      });

      // Existing items first (in their order), then new items from payload last
      const resultArray = [];
      const seenIds = new Set();
      state.propertiesData?.forEach((obj) => {
        resultArray.push(objectDictionary[obj["id"]]);
        seenIds.add(obj["id"]);
      });
      action.payload?.data?.forEach((obj) => {
        if (!seenIds.has(obj["id"])) {
          resultArray.push(objectDictionary[obj["id"]]);
        }
      });
      state.propertiesData = resultArray;
      state.propertiesCount = action.payload?.count || 0;
      state.propertiesListLoaded = true;
      state.propertiesLoader = false;
      state.propertiesListError =
        action.payload?.success === false
          ? action.payload?.message || "Unable to load properties."
          : null;
    },
    fetchUserProperty(state, action) {
      state.propertyQuestion = {};
      state.userPropertyData = action.payload;
      // Clear prior search result so retries start from a clean pending state.
      state.getPropertyData = {};
      state.propertyLoader = true;
      console.log("fet user property payload==>>", action.payload);
    },
    setUserPropertyData(state, action) {
      console.log("In Property slice...", action.payload);
      if (getObjLength(action.payload)) {
        state.getPropertyData = action.payload;
        state.verifiedPropertiesList = {};
        state.propertyVerified = {};
      }
      state.propertyLoader = false;
    },
    addNewProperty(state, action) {
      console.log("New property slice..", action.payload);
      state.getPropertyData = {};
      state.userPropertyData = {};
      state.selectedProperty = {};
      state.propertyQuestion = {};
      state.getSearchedPropertyData = {};
      state.genearteQuesPayload = {};
      // state.errorFlagCount = 0;
    },
    clearSearchedPropertyData(state, action) {
      console.log("New property slice..", action.payload);
      state.getPropertyData = {};
      state.userPropertyData = {};
      state.getSearchedPropertyData = {};
      state.selectedProperty = {};
    },
    generateQuestions(state, action) {
      state.propertyLoader = true;
      console.log("In generateQuestions slice...", action.payload);
    },
    generateQuestionsInputParams(state, action) {
      console.log("In generateQuestions params slice...", action.payload);
      state.genearteQuesPayload = action.payload;
    },
    setGeneratedQuestionsData(state, action) {
      console.log("In statecode slice...", action.payload);
      state.propertyQuestion = action.payload;
      state.propertyLoader = false;
      if (action.payload?.success) {
        state.getSearchedPropertyData = action.payload;
      }
      state.verifiedPropertiesList = {};
    },
    editPropertiesDetails(state, action) {
      state.propertyLoader = true;
      console.log("In edit property slice...", action.payload);
    },
    setEditPropertiesData(state, action) {
      console.log("In edit property slice...", action.payload);
      state.editPropertiesDetails = action.payload;
      state.propertyLoader = false;
    },
    showSecurityInfoScreen(state, action) {
      state.showSecurityInfoScreen = action.payload;
    },
    securityPropertiesQueDetails(state, action) {
      state.propertyLoader = true;
      console.log("In security generateQuestions slice...", action.payload);
    },
    setSecurityPropertiesQueData(state, action) {
      console.log("In security Properties Que  slice...", action.payload);
      state.securityPropertiesQueData = action.payload;
      state.propertyLoader = false;
    },
    verifySecurityInfoDetails(state, action) {
      state.propertyLoader = true;
      console.log("In security generateQuestions slice...", action.payload);
    },
    fetchVerifySecurityInfoData(state, action) {
      console.log("In security Properties Que  slice...", action.payload);
      state.verifySecurityInfoData = action.payload;
      state.propertyLoader = false;
    },
    setStopSubscriptionData(state, action) {
      console.log("In StopSubscription  slice...", action.payload);
      state.propertyLoader = true;
    },
    fetchStopSubscriptionDetails(state, action) {
      state.propertyLoader = false;
      state.stopSubscriptionData = action.payload;
      console.log("In Stop Subscription slice...", action.payload);
    },
    clearGeneratedQuestionsData(state, action) {
      console.log("In statecode slice...", action.payload);
      state.propertyQuestion = {};
      state.userPropertyData = {};
      state.getPropertyData = {};
      state.propertyVerified = {};
      state.selectedProperty = {};
      state.editPropertiesDetails = {};
      state.propertyLoader = false;
      state.verifiedPropertiesList = {};
      state.isQuestionByPass = false;
    },
    selectedUserPropertyData(state, action) {
      console.log("In selected Property slice...", action.payload);
      state.selectedProperty = action.payload;
    },
    verifyAnswers(state, action) {
      console.log("In verify answer slice...", action.payload);
    },
    setVerifedAnswersData(state, action) {
      console.log("In verify answer slice...", action.payload);
      state.propertyVerified = action.payload;
    },
    clearVerifedAnswersData(state, action) {
      console.log("In verify answer slice...", action.payload);
      state.propertyVerified = {};
    },
    setVerificationLoader(state, action) {
      state.verificationLoader = action.payload;
    },
    getDocumentTypes(state, action) {},
    fetchDocumentTypeList(state, action) {
      console.log("Document type list slice ...", action.payload);
      state.documentTypes = action.payload;
    },
    reqDocument(state, action) {
      state.reqLoader = true;
    },
    fethRequestedDoc(state, action) {
      console.log("reqDocument slice==>", action.payload);
      state.requestDoc = action.payload;
      state.reqLoader = false;
    },
    generateDocument(state, action) {
      state.reqLoader = true;
    },
    fethGeneratedDoc(state, action) {
      console.log("getGeneratedDoc slice==>", action.payload);
      state.generateDoc = action.payload;
      state.reqLoader = false;
    },
    paymentForProperty(state, action) {
      console.log("paymentForProperty slice==>", action.payload);
      state.paymentLoader = true;
    },
    fethPayment(state, action) {
      console.log("getGeneratedDoc slice==>", action.payload);
      state.propertyPayment = action.payload;
      state.paymentLoader = false;
    },
    cancelSubscription(state, action) {
      state.cancelSubscriptionLoader = true;
      state.cancelSubscriptionMetaData = action.payload;
    },
    setCancelSubscription(state, action) {
      state.cancelSubscriptionDetails = action.payload;

      let data = {
        email: decryptPayload(localStorage.getItem("loggedInEmail")),
        propertyAddress: state.cancelSubscriptionMetaData?.propertyAddress,
        type: state.cancelSubscriptionMetaData?.data?.type,
      };
      if (action.payload?.success) {
        reactPixelEventOnlyForCustomer("Cancel Subscription", data);
      }
      state.cancelSubscriptionLoader = false;
    },
    clearCancelSubscriptionStates(state, action) {
      state.cancelSubscriptionDetails = {};
      state.cancelSubscriptionLoader = false;
    },
    getViewPropertyDetails(state, action) {
      if (state.viewPropertyDetailLoader) {
        return;
      }
      if (!state.userViewDetailsPropertyData?.success) {
        state.userViewDetailsPropertyData = {};
        state.viewPropertyDetailLoader = true;
      }
    },
    setViewPropertyDetails(state, action) {
      state.userViewDetailsPropertyData = action?.payload;
      state.viewPropertyDetailLoader = false;
    },
    setViewDetailsPropertyData(state, action) {
      state.viewDetailsPropertyData = action.payload;
    },
    clearOrderDoc(state, action) {
      state.requestDoc = {};
      state.generateDoc = {};
      state.reqLoader = false;
    },
    fetchSubscriptionHistory(state, action) {
      state.subscriptionHistoryLoader = true;
    },
    clearSubscriptionHistory(state) {
      state.subscriptionHistory = {};
      state.subscriptionHistoryLoader = false;
    },
    setSubscriptionHistory(state, action) {
      state.subscriptionHistory = action.payload;
      state.subscriptionHistoryLoader = false;
    },
    setSelectedUserID(state, action) {
      state.selectedUserID = action.payload;
    },
    setIsQuestionByPass(state, action) {
      state.isQuestionByPass = action.payload;
    },
    setIsSubscriptionByPass(state, action) {
      state.isSubscriptionByPass = action.payload;
    },
    setIsBypassOptionAvailable(state, action) {
      state.isBypassOptionAvailable = action.payload;
    },
    addPropertySubscription(state, action) {
      state.addSubscriptionLoader = true;
    },
    setAddPropertySubscription(state, action) {
      state.addSubscriptionDetails = action.payload;
      console.log("addPropertySubscription==:>", action.payload);
      if (action.payload?.success && !action.payload?.data?.actionRequired) {
        if (action.payload?.success) {
          reactPixelEventOnlyForCustomer(
            "Add Subscription Successfully",
            JSON.parse(localStorage.getItem("PlanDetails")),
          );
        } else {
          reactPixelEventOnlyForCustomer(
            "Add Subscription Failed",
            JSON.parse(localStorage.getItem("PlanDetails")),
          );
        }
        localStorage.removeItem("PlanDetails");
      }
      state.addSubscriptionLoader = false;
    },
    selectedPropertiesData(state, action) {
      state.selectedPropertiesData = action.payload;
    },
    getBasicMonitoringData(state, action) {
      state.basicMonitoringLoader = true;
      state.basicMonitoringData = {};
    },
    fetchBasicMonitoringDetails(state, action) {
      state.basicMonitoringData = action?.payload;
      state.basicMonitoringLoader = false;
    },
    fetchTtbDocument(state) {
      state.ttbDocumentLoader = true;
    },
    setTtbDocument(state, action) {
      state.ttbDocumentDetails = action?.payload;
      state.ttbDocumentLoader = false;
    },
    clearTtbDocument(state) {
      state.ttbDocumentDetails = {};
      state.ttbDocumentLoader = false;
    },
  },
});
export const propertiesAction = properties.actions;
export default properties.reducer;
